import { RichTextSpanAttributeType } from "../../model/enums/SDKRichTextSpanAttributeType";
import { TokenTransform } from "../token-transform/SDKToolsTokenTransform";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Definitions
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Search Instance
/** Markdown block transformer */
export class MarkdownTransformUtil {
    // --- Conversion
    constructor() {
        this.tokenTransformer = new TokenTransform();
    }
    // --- Conversion
    /** Converts rich text block to markdown
     *
     * This is very naive implementation and will break in complicated cases, like double control characters of the same type next to each other
     * Must improve later with something more sophisticated, ideally tree builder with branched resolution.
     */
    convertTextBlockToMarkdown(block) {
        return this.convertRichTextToMarkdown(block.text);
    }
    /** Converts rich text to markdown
     *
     * This is very naive implementation and will break in complicated cases, like double control characters of the same type next to each other
     * Must improve later with something more sophisticated, ideally tree builder with branched resolution.
     */
    convertRichTextToMarkdown(richText) {
        var _a;
        let outputString = "";
        for (const text of richText.spans) {
            if (text.text.length > 0) {
                let outputPartial = text.text;
                for (const attribute of text.attributes) {
                    switch (attribute.type) {
                        case RichTextSpanAttributeType.link:
                            outputPartial = `[${outputPartial}](${(_a = attribute.link) !== null && _a !== void 0 ? _a : ""})`;
                            break;
                        case RichTextSpanAttributeType.bold:
                            outputPartial = `*${outputPartial}*`;
                            break;
                        case RichTextSpanAttributeType.code:
                            outputPartial = `\`${outputPartial}\``;
                            break;
                        case RichTextSpanAttributeType.italic:
                            outputPartial = `_${outputPartial}**_`;
                            break;
                        case RichTextSpanAttributeType.strikethrough:
                            outputPartial = `~~${outputPartial}~~`;
                            break;
                        default:
                            throw new Error("Unknown attribute type");
                    }
                }
                outputString += outputPartial;
            }
        }
        return outputString;
    }
    /** Convert token to markdown representation */
    convertTokenToMarkdown(token) {
        return `${token.name}: ${this.tokenTransformer.tokenToCSS(token)}`;
    }
}
